// Legal page content for Terms of Service and Privacy Policy.
// Three languages: lt (primary), ru, en.
// Last updated: 2026-02-05

export const LEGAL_LAST_UPDATED = "2026-02-08";

export const LEGAL_CONTENT = {
  terms: {
    lt: {
      title: "Naudojimosi sąlygos",
      sections: [
        {
          h: "1. Bendrosios nuostatos",
          p: [
            "Sveiki atvykę į StopChlamas (toliau – „Platforma“ arba „mes“). Naudodamiesi mūsų svetaine ir paslaugomis sutinkate su šiomis Naudojimosi sąlygomis. Jeigu nesutinkate – prašome platformos nenaudoti.",
            "Platforma yra skelbimų portalas, skirtas garažo daiktams (įrankiams, auto detalėms, sodo technikai ir pan.) parduoti, atiduoti, mainyti ar varžytis aukcione. Veikiame Lietuvos Respublikoje.",
          ],
        },
        {
          h: "2. Vartotojo paskyra",
          p: [
            "Norėdamas įkelti skelbimą ar bendrauti su pardavėjais, vartotojas turi sukurti paskyrą (el. pašto + slaptažodžio arba Google paskyros pagrindu). Esi atsakingas už savo prisijungimo duomenų saugumą.",
            "Privalai pateikti teisingus ir aktualius duomenis. Draudžiama kurti netikras paskyras, naudoti svetimą tapatybę ar mėginti apeiti saugumo priemones.",
          ],
        },
        {
          h: "3. Skelbimai ir turinys",
          p: [
            "Šiuo metu visi skelbimai yra NEMOKAMI. Vartotojas pats atsako už skelbimo turinį, nuotraukas, kainą ir prekės būklės teisingą aprašymą.",
            "Draudžiama skelbti: nelegalias prekes, ginklus, narkotikus, suklastotas prekes, gyvūnus, asmens duomenis tretiesiems asmenims, įžeidžiantį ar diskriminuojantį turinį, taip pat prekes, kurioms reikia specialios licencijos.",
            "Mes pasiliekame teisę be išankstinio įspėjimo pašalinti bet kurį skelbimą, pažeidžiantį šias sąlygas arba Lietuvos Respublikos teisės aktus.",
          ],
        },
        {
          h: "4. Sandoriai tarp vartotojų",
          p: [
            "StopChlamas yra TIK SKELBIMŲ PLATFORMA. Mes nesame sandorio šalis ir neatsakome už prekės kokybę, pristatymą, atsiskaitymą tarp pirkėjo ir pardavėjo.",
            "Visi sandoriai vyksta tiesiogiai tarp vartotojų. Rekomenduojame susitikti viešoje vietoje, prekę apžiūrėti prieš mokant, o didesnėms sumoms – naudoti banko pavedimą.",
          ],
        },
        {
          h: "5. Aukcionai 24h",
          p: [
            "Aukciono trukmė – 24 valandos nuo skelbimo paskelbimo. Pasibaigus laikui, didžiausią pasiūlymą pateikęs vartotojas laimi ir privalo susisiekti su pardavėju per 48 valandas, kad sutartų atsiėmimo ir atsiskaitymo sąlygas.",
            "Pasiūlymo atšaukti negalima. Nesilaikymas susitarimo gali sukelti paskyros blokavimą.",
          ],
        },
        {
          h: "6. Atsakomybės ribojimas",
          p: [
            "Platforma teikiama „tokia, kokia yra“. Mes nesuteikiame jokių garantijų dėl skelbimų teisingumo, vartotojų patikimumo ar paslaugos prieinamumo be pertraukų.",
            "Maksimalia įstatymų leidžiama apimtimi neatsakome už netiesioginius nuostolius, prarastą pelną ar duomenis.",
          ],
        },
        {
          h: "7. Paskyros nutraukimas",
          p: [
            "Tu gali bet kada panaikinti savo paskyrą, susisiekęs su mumis. Mes pasiliekame teisę nutraukti ar suspenduoti paskyras, kurios pažeidžia šias sąlygas, sukčiauja ar kelia grėsmę kitiems vartotojams.",
          ],
        },
        {
          h: "8. Sąlygų pakeitimai",
          p: [
            "Šios sąlygos gali būti atnaujinamos. Esminius pakeitimus paskelbsime svetainėje ir, jei būtina, pranešime el. paštu. Tolesnis naudojimasis Platforma reiškia sutikimą su pakeitimais.",
          ],
        },
        {
          h: "9. Taikoma teisė",
          p: [
            "Šioms sąlygoms taikoma Lietuvos Respublikos teisė. Visi ginčai sprendžiami Lietuvos Respublikos teismuose pagal įstatymais nustatytą jurisdikciją.",
          ],
        },
      ],
    },
    ru: {
      title: "Условия использования",
      sections: [
        {
          h: "1. Общие положения",
          p: [
            "Добро пожаловать на StopChlamas (далее — «Платформа» или «мы»). Используя сайт и услуги, вы соглашаетесь с настоящими Условиями. Если не согласны — пожалуйста, не пользуйтесь Платформой.",
            "Платформа — это доска объявлений для гаражных вещей (инструменты, автозапчасти, садовая техника и т.д.) для продажи, отдачи, обмена и аукционов. Работаем на территории Литовской Республики.",
          ],
        },
        {
          h: "2. Учётная запись пользователя",
          p: [
            "Для размещения объявлений и общения с продавцами необходимо создать учётную запись (email+пароль или через Google). Ты несёшь ответственность за сохранность своих данных входа.",
            "Обязан указывать достоверные и актуальные данные. Запрещено создавать фейковые аккаунты и использовать чужую личность.",
          ],
        },
        {
          h: "3. Объявления и контент",
          p: [
            "Сейчас все объявления БЕСПЛАТНЫ. Пользователь сам отвечает за содержание объявления, фотографии, цену и точное описание состояния товара.",
            "Запрещено публиковать: нелегальные товары, оружие, наркотики, контрафакт, животных, чужие персональные данные, оскорбительный или дискриминационный контент, а также товары, требующие специальной лицензии.",
            "Мы оставляем за собой право без предупреждения удалить любое объявление, нарушающее настоящие условия или законодательство ЛР.",
          ],
        },
        {
          h: "4. Сделки между пользователями",
          p: [
            "StopChlamas — это ТОЛЬКО ПЛОЩАДКА ОБЪЯВЛЕНИЙ. Мы не являемся стороной сделки и не отвечаем за качество товара, доставку, расчёты между покупателем и продавцом.",
            "Все сделки происходят напрямую. Рекомендуем встречаться в публичных местах, осматривать товар до оплаты, а для крупных сумм — использовать банковский перевод.",
          ],
        },
        {
          h: "5. Аукционы 24 часа",
          p: [
            "Длительность аукциона — 24 часа с момента публикации. По окончании срока выигрывает тот, кто предложил наибольшую цену, и должен связаться с продавцом в течение 48 часов.",
            "Ставку отменить нельзя. Несоблюдение договорённостей может привести к блокировке аккаунта.",
          ],
        },
        {
          h: "6. Ограничение ответственности",
          p: [
            "Платформа предоставляется «как есть». Мы не даём гарантий относительно точности объявлений, надёжности пользователей или непрерывности работы сервиса.",
            "В пределах, разрешённых законом, не отвечаем за косвенные убытки, упущенную выгоду или утрату данных.",
          ],
        },
        {
          h: "7. Прекращение аккаунта",
          p: [
            "Ты можешь удалить свой аккаунт в любое время, связавшись с нами. Мы оставляем за собой право прекратить или приостановить аккаунты, нарушающие условия, мошеннические или угрожающие другим пользователям.",
          ],
        },
        {
          h: "8. Изменения условий",
          p: [
            "Настоящие условия могут обновляться. О существенных изменениях мы сообщим на сайте и, при необходимости, по email. Дальнейшее использование Платформы означает согласие с изменениями.",
          ],
        },
        {
          h: "9. Применимое право",
          p: [
            "К настоящим условиям применяется право Литовской Республики. Все споры разрешаются в судах ЛР.",
          ],
        },
      ],
    },
    en: {
      title: "Terms of Service",
      sections: [
        {
          h: "1. General",
          p: [
            "Welcome to StopChlamas (the “Platform” or “we”). By using our website and services you agree to these Terms of Service. If you do not agree, please do not use the Platform.",
            "The Platform is a classified ads marketplace for garage items (tools, auto parts, garden equipment, etc.) for sale, give-away, trade or 24-hour auctions. We operate from the Republic of Lithuania.",
          ],
        },
        {
          h: "2. User accounts",
          p: [
            "To post a listing or message sellers you must create an account (email/password or Google sign-in). You are responsible for keeping your credentials secure.",
            "You must provide accurate and up-to-date information. Creating fake accounts or impersonating others is forbidden.",
          ],
        },
        {
          h: "3. Listings and content",
          p: [
            "All listings are currently FREE. You are solely responsible for the content of your listing, photos, price and accurate description of the item’s condition.",
            "It is forbidden to post: illegal goods, weapons, drugs, counterfeit items, animals, third-party personal data, hateful or discriminatory content, or items that require a special license.",
            "We reserve the right to remove any listing that violates these terms or Lithuanian law without prior notice.",
          ],
        },
        {
          h: "4. Transactions between users",
          p: [
            "StopChlamas is ONLY A LISTINGS PLATFORM. We are not a party to any transaction and are not liable for item quality, shipping or payment between buyer and seller.",
            "All transactions happen directly between users. We recommend meeting in public places, inspecting items before paying, and using bank transfers for larger amounts.",
          ],
        },
        {
          h: "5. 24-hour auctions",
          p: [
            "Auction duration is 24 hours from publishing. The highest bidder at the end wins and must contact the seller within 48 hours to arrange pickup and payment.",
            "Bids cannot be cancelled. Failing to honour the agreement may lead to account suspension.",
          ],
        },
        {
          h: "6. Limitation of liability",
          p: [
            "The Platform is provided “as is”. We make no warranties regarding the accuracy of listings, reliability of users or continuous availability of the service.",
            "To the maximum extent permitted by law we are not liable for indirect damages, loss of profits or data.",
          ],
        },
        {
          h: "7. Account termination",
          p: [
            "You may close your account at any time by contacting us. We may terminate or suspend accounts that breach these terms, engage in fraud or threaten other users.",
          ],
        },
        {
          h: "8. Changes to the terms",
          p: [
            "These terms may be updated. We will publish material changes on the site and, where appropriate, notify you by email. Continued use of the Platform constitutes acceptance of the changes.",
          ],
        },
        {
          h: "9. Governing law",
          p: [
            "These terms are governed by the laws of the Republic of Lithuania. Disputes are resolved in Lithuanian courts under applicable jurisdiction.",
          ],
        },
      ],
    },
  },

  privacy: {
    lt: {
      title: "Privatumo politika",
      sections: [
        {
          h: "1. Kas mes esame",
          p: [
            "StopChlamas (toliau – „mes“) – skelbimų platforma, veikianti Lietuvoje. Ši privatumo politika paaiškina, kokius asmens duomenis renkame, kaip juos naudojame, saugome ir kokias turi teises pagal ES Bendrąjį duomenų apsaugos reglamentą (BDAR).",
          ],
        },
        {
          h: "2. Kokius duomenis renkame",
          p: [
            "Registracijos duomenys: vardas, el. pašto adresas, slaptažodžio maišos kodas (hash), pasirinktinai – telefonas ir adresas. Jeigu prisijungi per Google, gauname tavo vardą, el. paštą ir profilio nuotrauką.",
            "Skelbimų duomenys: pavadinimas, aprašymas, kategorija, miestas, koordinatės (apytikslės pagal pasirinktą miestą), kaina, nuotraukos.",
            "Pranešimų duomenys: tarp vartotojų siunčiamos žinutės ir nuotraukos.",
            "Techniniai duomenys: IP adresas, naršyklės tipas, prisijungimo laikas (prisijungimo žurnalai).",
          ],
        },
        {
          h: "3. Kodėl renkame šiuos duomenis (teisinis pagrindas)",
          p: [
            "Sutarties vykdymas: kad galėtum naudotis paskyra, įkelti skelbimus ir bendrauti su kitais vartotojais.",
            "Teisėtas interesas: užkirsti kelią sukčiavimui, gerinti paslaugą ir užtikrinti svetainės saugumą.",
            "Sutikimas: žinučių pranešimams ir, jei pritaikoma ateityje, naujienlaiškiams.",
          ],
        },
        {
          h: "4. Kam atskleidžiame duomenis",
          p: [
            "Kitiems vartotojams: tavo vardas, profilio nuotrauka ir įvertinimai matomi viešai prie tavo skelbimų.",
            "Paslaugų teikėjams: debesų infrastruktūra (serveris ir duomenų bazė), nuotraukų saugykla, autentifikacija (Google). Visi tvarko duomenis pagal sutartis ir BDAR reikalavimus.",
            "Teisėsaugai: tik gavus teisėtą prašymą pagal LR įstatymus.",
          ],
        },
        {
          h: "5. Duomenų saugojimo terminai",
          p: [
            "Paskyros duomenys saugomi tol, kol egzistuoja paskyra. Po paskyros panaikinimo asmens duomenys ištrinami arba anonimizuojami per 30 dienų, išskyrus tuos, kuriuos privalome išsaugoti pagal įstatymus (pvz., apskaitos dokumentus).",
            "Skelbimai saugomi tol, kol vartotojas jų neištrina arba paskyra neuždaryta.",
            "Žinutės tarp vartotojų saugomos saugumo ir ginčų sprendimo tikslais.",
          ],
        },
        {
          h: "6. Tavo teisės pagal BDAR",
          p: [
            "Turi teisę: gauti informaciją apie tvarkomus duomenis; juos taisyti; ištrinti („teisė būti pamirštam“); apriboti tvarkymą; perkelti į kitą paslaugą; nesutikti su tvarkymu; pateikti skundą Valstybinei duomenų apsaugos inspekcijai (VDAI, https://vdai.lrv.lt).",
            "Norėdamas pasinaudoti šiomis teisėmis, susisiek su mumis: support@stopchlamas.lt.",
          ],
        },
        {
          h: "7. Slapukai (cookies)",
          p: [
            "Naudojame tik būtinuosius slapukus, reikalingus prisijungimo sesijai išlaikyti. Statistikos ar reklamos slapukų nediegiame. Naršyklėje gali blokuoti slapukus, tačiau tada gali neveikti prisijungimas.",
          ],
        },
        {
          h: "8. Duomenų saugumas",
          p: [
            "Slaptažodžiai saugomi naudojant bcrypt maišą. Komunikacija šifruojama HTTPS. Prieiga prie duomenų bazės apribota tik administraciniam personalui.",
          ],
        },
        {
          h: "9. Vaikai",
          p: [
            "Platforma skirta 16 metų ir vyresniems asmenims. Jei sužinome, kad jaunesnis vaikas užregistravo paskyrą be tėvų sutikimo, paskyrą ištrinsime.",
          ],
        },
        {
          h: "10. Kontaktai",
          p: [
            "Klausimai dėl privatumo: support@stopchlamas.lt. Atsakome per 30 dienų pagal BDAR.",
          ],
        },
      ],
    },
    ru: {
      title: "Политика конфиденциальности",
      sections: [
        {
          h: "1. Кто мы",
          p: [
            "StopChlamas (далее — «мы») — площадка объявлений, действующая в Литве. Настоящая политика объясняет, какие персональные данные мы собираем, как используем, храним, и какие у тебя права согласно GDPR ЕС.",
          ],
        },
        {
          h: "2. Какие данные мы собираем",
          p: [
            "Регистрационные данные: имя, email, хеш пароля, по желанию — телефон и адрес. При входе через Google получаем имя, email и фото профиля.",
            "Данные объявлений: название, описание, категория, город, координаты (приблизительно по выбранному городу), цена, фото.",
            "Данные сообщений: сообщения и фото между пользователями.",
            "Технические данные: IP-адрес, тип браузера, время входа.",
          ],
        },
        {
          h: "3. Зачем мы собираем данные (правовое основание)",
          p: [
            "Исполнение договора: чтобы ты мог пользоваться аккаунтом, размещать объявления и общаться.",
            "Законный интерес: предотвращение мошенничества, улучшение сервиса, безопасность.",
            "Согласие: уведомления и, если будет в будущем, рассылки.",
          ],
        },
        {
          h: "4. Кому передаём данные",
          p: [
            "Другим пользователям: имя, фото профиля и оценки видны публично рядом с твоими объявлениями.",
            "Поставщикам услуг: облачная инфраструктура, хранилище фото, аутентификация Google. Все обрабатывают данные по договору и согласно GDPR.",
            "Правоохранителям: только по законному запросу.",
          ],
        },
        {
          h: "5. Сроки хранения",
          p: [
            "Данные аккаунта хранятся пока существует аккаунт. После удаления данные удаляются или обезличиваются в течение 30 дней, кроме тех, что обязаны хранить по закону.",
            "Объявления хранятся пока пользователь их не удалит.",
            "Сообщения между пользователями хранятся для целей безопасности и разрешения споров.",
          ],
        },
        {
          h: "6. Твои права по GDPR",
          p: [
            "Имеешь право: получать информацию о данных; исправлять их; удалить («право на забвение»); ограничить обработку; перенести в другой сервис; возразить против обработки; подать жалобу в Государственную инспекцию защиты данных Литвы (VDAI).",
            "Для реализации прав напиши: support@stopchlamas.lt.",
          ],
        },
        {
          h: "7. Cookies",
          p: [
            "Используем только необходимые cookies для сессии входа. Статистических или рекламных cookies нет. В браузере можно отключить, но тогда вход может не работать.",
          ],
        },
        {
          h: "8. Безопасность данных",
          p: [
            "Пароли хранятся с использованием bcrypt. Связь шифруется HTTPS. Доступ к базе данных ограничен.",
          ],
        },
        {
          h: "9. Дети",
          p: [
            "Платформа для лиц 16 лет и старше. Если узнаем о младшем без согласия родителей — аккаунт будет удалён.",
          ],
        },
        {
          h: "10. Контакты",
          p: [
            "Вопросы о конфиденциальности: support@stopchlamas.lt. Отвечаем в течение 30 дней согласно GDPR.",
          ],
        },
      ],
    },
    en: {
      title: "Privacy Policy",
      sections: [
        {
          h: "1. Who we are",
          p: [
            "StopChlamas (“we”) is a classified ads platform operating from Lithuania. This policy explains what personal data we collect, how we use and store it, and what rights you have under the EU General Data Protection Regulation (GDPR).",
          ],
        },
        {
          h: "2. What data we collect",
          p: [
            "Registration data: name, email, password hash, optionally phone and address. If you sign in with Google we receive your name, email and profile picture.",
            "Listing data: title, description, category, city, approximate coordinates (based on chosen city), price, photos.",
            "Message data: messages and photos exchanged between users.",
            "Technical data: IP address, browser type, login timestamps.",
          ],
        },
        {
          h: "3. Why we collect this data (legal basis)",
          p: [
            "Performance of contract: to let you use your account, post listings and message users.",
            "Legitimate interest: preventing fraud, improving the service and ensuring security.",
            "Consent: for notifications and, if applicable in the future, newsletters.",
          ],
        },
        {
          h: "4. Who we share data with",
          p: [
            "Other users: your name, profile picture and ratings are visible publicly next to your listings.",
            "Service providers: cloud infrastructure, image storage, Google authentication — all bound by contracts and GDPR-compliant terms.",
            "Law enforcement: only upon a lawful request under Lithuanian law.",
          ],
        },
        {
          h: "5. Data retention",
          p: [
            "Account data is kept while the account exists. After deletion personal data is removed or anonymised within 30 days, except where law requires longer retention.",
            "Listings remain until the user deletes them or closes the account.",
            "Messages between users are kept for safety and dispute resolution.",
          ],
        },
        {
          h: "6. Your rights under GDPR",
          p: [
            "You have the right to: access your data, correct it, erase it (“right to be forgotten”), restrict processing, port it to another service, object to processing, and lodge a complaint with the Lithuanian State Data Protection Inspectorate (VDAI).",
            "To exercise these rights contact: support@stopchlamas.lt.",
          ],
        },
        {
          h: "7. Cookies",
          p: [
            "We only use essential cookies for login sessions. We do not use analytics or advertising cookies. You can block cookies in your browser, but then sign-in may not work.",
          ],
        },
        {
          h: "8. Data security",
          p: [
            "Passwords are stored using bcrypt hashing. Communication is encrypted via HTTPS. Database access is restricted to administrative personnel.",
          ],
        },
        {
          h: "9. Children",
          p: [
            "The Platform is for users aged 16+. If we learn that a younger child has registered without parental consent we will delete the account.",
          ],
        },
        {
          h: "10. Contact",
          p: [
            "Privacy questions: support@stopchlamas.lt. We reply within 30 days as required by GDPR.",
          ],
        },
      ],
    },
  },
};
